// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "assets_js_common_components_Popin_js") return "./js/chunks/8d695c415233c72f0c63.js";
	if (chunkId === "assets_js_common_modules_appNav_js") return "./js/chunks/a23dc8495a20023231d7.js";
	if (chunkId === "assets_js_common_modules_formInput_js") return "./js/chunks/034edd4a008bfd97d381.js";
	if (chunkId === "assets_js_common_services_XhrService_js") return "./js/chunks/0d0f04f76f50df02a8d2.js";
	if (chunkId === "assets_js_crm_modules_contactDetail_js") return "./js/chunks/c193acd5e08f9e60df6a.js";
	if (chunkId === "assets_js_crm_partials_formSetAssistant_js") return "./js/chunks/d20879029902da587c7a.js";
	if (chunkId === "assets_js_crm_modules_formContact_js") return "./js/chunks/7f91699dc46e90254a51.js";
	if (chunkId === "assets_js_crm_modules_formContactList_js") return "./js/chunks/72e918b7dc5747c054b2.js";
	if (chunkId === "assets_js_crm_partials_formSetManager_js") return "./js/chunks/0770b576acfcfa734a4e.js";
	if (chunkId === "assets_js_crm_partials_formSetPhone_js") return "./js/chunks/78a7977337e14daa2d2e.js";
	if (chunkId === "assets_js_translate_modules_formTranslate_js") return "./js/chunks/2e43af818ec8e2ebc052.js";
	// return url for filenames based on template
	return undefined;
};